(function ($) {
  'use strict';

  var BREAKPOINT   = 992;
  var modalId      = 'wheeler-filter-modal';
  var triggerId    = 'wheeler-filter-trigger';
  var $filtersEl   = null;
  var $placeholder = null;
  var formMoved    = false;

  /* ── Encuentra el form de filtros ── */
  function findFilters() {
    var selectors = [
      '.view-lista-de-contratos .view-filters',
      '.view-filters',
      '.views-exposed-form'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var $el = $(selectors[i]).first();
      if ($el.length) return $el;
    }
    return null;
  }

  /* ── Badge: cuenta filtros activos en la URL ── */
  function updateBadge() {
    var params = new URLSearchParams(window.location.search);
    var count = 0;
    params.forEach(function (val, key) {
      if (key !== 'page' && key !== 'datauser' && val !== '' && val !== '0') count++;
    });
    var $badge = $('#' + triggerId + ' .filter-badge');
    if (count > 0) { $badge.text(count).show(); }
    else           { $badge.hide(); }
  }

  /* ── Mueve form al modal ── */
  function moveToModal() {
    if (formMoved || !$filtersEl) return;
    var $body = $('#' + modalId + '-body');
    $placeholder = $('<span class="wheeler-filter-placeholder" style="display:none;"></span>');
    $filtersEl.before($placeholder);
    $body.empty().append($filtersEl);
    formMoved = true;
  }

  /* ── Regresa form a posición original ── */
  function moveToOriginal() {
    if (!formMoved || !$filtersEl || !$placeholder) return;
    $placeholder.after($filtersEl);
    formMoved = false;
  }

  /* ── Bindings del modal ── */
  function bindModal() {
    var $modal = $('#' + modalId);
    if (!$modal.length) return;

    $modal.on('show.bs.modal', function () {
      if (!$filtersEl) $filtersEl = findFilters();
      if ($filtersEl && !formMoved) moveToModal();
    });

    $modal.on('hidden.bs.modal', function () {
      moveToOriginal();
    });

    // Submit: cerrar modal y enviar el form
    $modal.on('click', 'input[type="submit"].form-submit', function (e) {
      e.preventDefault();
      var $btn = $(this);
      var instance = bootstrap.Modal.getInstance(document.getElementById(modalId));
      if (instance) {
        $modal.one('hidden.bs.modal', function () { $btn.trigger('click'); });
        instance.hide();
      } else {
        $btn.trigger('click');
      }
    });

    // Reset
    $modal.on('click', '#edit-reset', function (e) {
      e.preventDefault();
      window.location.assign(window.location.pathname + (window.location.hash || ''));
    });
  }

  /* ── Setup responsive ── */
  function setup() {
    var $trigger = $('#' + triggerId);
    if (!$trigger.length) return; // no estamos en una página con filtros

    var isMobile = $(window).width() < BREAKPOINT;

    if (isMobile) {
      // Encontrar filtros y ocultarlos del DOM normal
      if (!$filtersEl) $filtersEl = findFilters();
      if ($filtersEl && !formMoved) $filtersEl.hide();

      $trigger.css('display', 'block'); // override el style="display:none!important"
      updateBadge();
    } else {
      // Desktop: mostrar form normal, ocultar trigger
      moveToOriginal();
      if ($filtersEl) $filtersEl.show();
      $trigger.css('display', 'none');
    }
  }

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  $(document).ready(function () {
    bindModal();
    setup();
    $(window).on('resize', debounce(setup, 200));
  });

})(jQuery);
